import React from 'react';
import { FiTwitter, FiInstagram, FiNavigation } from 'react-icons/fi';

import { FooterOverlay, Newsletter } from '../../components';
import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <FooterOverlay />
    <Newsletter />

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">5461 Merchants View Square Haymarket, VA 20169</p>
        <p className="p__opensans">703-753-5586</p>
      </div>

      <div className="app__footer-links_logo">
        <img src={images.divinenail} alt="footer_logo" />
        <p className="p__opensans">&quot;The wellness enhancements of beauties.&quot;</p>
        <img src={images.spoon} className="spoon__img" style={{ marginTop: 15 }} />
        <div className="app__footer-links_icons">
          <FiNavigation />
          {/* https://g.co/kgs/yABmgA5*/}
    
          <FiTwitter />
          <FiInstagram />
          {/* https://www.instagram.com/divinenail_haymarket/ */}
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Monday-Friday:</p>
        <p className="p__opensans">10:00 am - 08:00 pm</p>
        <p className="p__opensans">Saturday:</p>
        <p className="p__opensans">09:00 am - 06:00 pm</p>
        <p className="p__opensans">Sunday:</p>
        <p className="p__opensans">10:00 am - 05:00 pm</p>
      </div>
    </div>

  </div>
);

export default Footer;